import { render, staticRenderFns } from "./QuickMessageDrawer.vue?vue&type=template&id=1e960834&scoped=true&"
import script from "./QuickMessageDrawer.vue?vue&type=script&lang=js&"
export * from "./QuickMessageDrawer.vue?vue&type=script&lang=js&"
import style0 from "./QuickMessageDrawer.vue?vue&type=style&index=0&id=1e960834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e960834",
  null
  
)

export default component.exports